<template>
  <div class="row">
    <div class="col-md-12">
      <InputGroup
          label="Policy Group Name"
          type="text"
          v-model="form.name"
          placeholder="policy group name"
          :required="true"
          :validation-error="errorFor('name')"
      />

      <div class="mb-3">
        <label for="policy_group" class="col-form-label">Policy</label>
        <Multiselect
            v-model="form.policies"
            :options="policies"
            :multiple="true"
            :showLabels="false"
            :close-on-select="true"
            placeholder="Select a policy"
            label="name"
            track-by="id"
            :optionHeight="20"
        />
        <v-errors :errors="errorFor('policy_ids')"></v-errors>
      </div>

      <TextareaField
          label="Description"
          v-model="form.description"
          placeholder="Description"
          :required="true"
          :validation-error="errorFor('description')"
      />

      <div class="my-3">
        <div class="d_flex_start">
          <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click="submit">
            {{ editId ? 'Update' : 'Submit' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import InputGroup from "@/components/FormControl/InputGroupComponent.vue";
import TextareaField from "@/components/FormControl/TextareaFieldComponent.vue";

export default {
  name: 'PolicyGroupForm',
  components: {Multiselect, TextareaField, InputGroup},
  props: ['closeModal', 'loadData', 'editId'],
  data() {
    return {
      lyLoading: false,
      form: {
        policies: '',
        policy_ids: []
      },
      policies: [],
    }
  },
  created() {
    if (this.editId) {
      this.getPolicy()
    }
    this.permissionList()
  },
  methods: {
    getPolicy() {
      this.axios.get(`/policy-groups/${this.editId}`)
          .then(({data}) => {
            let policy = data.data
            this.form = policy
          })
    },
    permissionList() {
      this.axios.get('/policy-list')
          .then(({data}) => {
            this.policies = data.data
          })
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let apiUrl;
      if (this.editId) {
        apiUrl = `policy-groups/${this.editId}`;
        this.form._method = 'PUT'
      } else {
        apiUrl = `policy-groups`;
      }

      if ( this.form.policies) {
        this.form.policy_ids = this.form.policies?.map((item) => item.id)
      }

      this.axios.post(apiUrl, this.form)
          .then(({data}) => {
            if (data.success) {
              this.loadData()
              this.showSuccessMsg(data.message);
              this.closeModal()
            } else {
              this.showFailMsg(data.message);
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>

</style>
  